import { MdLocationOn, MdWork } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import config from "@/config";


function BoxCompany({ data }) {
    const navigate = useNavigate()

    return (
        <div className="bg-white h-full p-4 rounded-lg shadow-md flex flex-col justify-between transition-all border-2 border-transparent hover:translate-y-[-5px] duration-200 hover:shadow-2xl  hover:border-primary-hover">

            <div className="relative pb-3 ">
                <img
                    src={config.ImageConfig.getBanner(data.BANNER1)}
                    alt="Banner"
                    className="w-full h-40 object-cover rounded bg-white shadow"
                />
                <Link to={config.routes.detailCompany + data.Pk}>
                    <img
                        src={config.ImageConfig.getLogo(data.PhotoCompany)}
                        alt="Logo"
                        className="relative w-24 h-24 object-contain rounded-lg mt-[-44px] hover:translate-y-[-5px] ml-6 shadow hover:shadow-2xl transition-all duration-200 bg-white cursor-pointer"
                    />
                </Link>
            </div>
            <div className="p-4 border-y border-blue-200">
                <Link to={config.routes.detailCompany + data.Pk} className="text-lg font-semibold hover:underline hover:text-primary-hover cursor-pointer line-clamp-2">{data.CompanyName}</Link>
                <div className="flex flex-col justify-start mt-2 text-gray-600">
                    <div className="flex items-center gap-1 text-sm ">
                        <MdLocationOn className="w-4 h-4 shrink-0" />
                        <p className="line-clamp-1">{data.ADDRESS}</p>
                    </div>
                    <div className="flex items-center gap-1 text-sm">
                        <MdWork className="w-4 h-4" />
                        <p className="line-clamp-1">{data.totalJobs} công việc</p>
                    </div>
                </div>
                <div className="text-justify line-clamp-2 md:line-clamp-3
                 mt-1 text-sm" dangerouslySetInnerHTML={{ __html: data.Description }} ></div>
            </div>
            <div className="p-4">
                <button onClick={() => navigate(config.routes.detailCompany + data.Pk)} className="w-full border text-primary border-primary hover:bg-primary-hover  hover:text-white py-2 rounded-lg font-semibold">
                    Thông tin chi tiết
                </button>
            </div>


        </div>
    );
}

export default BoxCompany;
